// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14fEy","content":"styles_content__2osJx","tableWrap":"styles_tableWrap__3kbhT"};